import { useCallback } from "react";
import { getTrackingProfile } from "../helper/userProfile";

export const useTracking = () => {
  const trackEvent = useCallback((eventName, payload) => {
    // gtag se define en index.html; si el script fue bloqueado, no rompemos la app
    if (typeof window.gtag === "function") {
      // Enviamos el evento a GA4, conservando sexo y edad del usuario
      window.gtag("event", eventName, {
        ...getTrackingProfile(),
        ...payload
      });
    }

    // Opcional: Console.log para debuguear en desarrollo
    if (import.meta.env.DEV) {
      console.log(`[Tracking] ${eventName}`, payload);
    }
  }, []);

  return { trackEvent };
};
